/**
 * Sport IQ — shared per-sport metadata (mirrors backend `SPORTS` in sport_iq_seeds.py).
 * Keeps the 4 Sport IQ pages branded per-sport without duplicating page components.
 */
export const SPORT_META = {
  basketball: {
    label: 'Basketball',
    tagline: 'Applying the Scenarios of Basketball IQ',
    hub_title: 'The IQ of Basketball',
    accent: '#FF5722',
    intro: 'Every term. Every read. Every decision. Built by Coach B for players and parents who want to see the game — not just what to do, but when and why.',
  },
  football: {
    label: 'Football',
    tagline: 'Applying the Scenarios of Football IQ',
    hub_title: 'The IQ of Football',
    accent: '#3B82F6',
    intro: 'Every coverage. Every front. Every read. Built by Coach B for quarterbacks, coordinators, and parents who want to see the game — not just what to run, but when to run it.',
  },
  soccer: {
    label: 'Soccer',
    tagline: 'Applying the Scenarios of Soccer IQ',
    hub_title: 'The IQ of Soccer',
    accent: '#22C55E',
    intro: 'Every press. Every third-man run. Every line-breaking pass. Built by Coach B for players and parents who want to see the game — not just what to do, but when and how.',
  },
  track: {
    label: 'Track & Field',
    tagline: 'Applying the Scenarios of Track IQ',
    hub_title: 'The IQ of Track',
    accent: '#EAB308',
    intro: 'Every stride. Every split. Every kick. Built by Coach B for athletes and parents who want to see race craft — the decisions that turn effort into victory.',
  },
};

export const getSportMeta = (sport) => SPORT_META[sport] || SPORT_META.basketball;
